import React from 'react';

import { InfiniteScrollContainer } from 'components/InfiniteScrollContainer/InfiniteScrollContainer';
import { AnnotationItem } from 'components/AnnotaionItem/AnnotationItem';

import { useAnnotationsInfiniteScroll } from 'components/UserProfile/hooks';

import { useOrdersTabContentStyles } from 'components/UserProfile/styles';

export const AnnotationsCard = () => {
  const { classes } = useOrdersTabContentStyles();

  const { items, loading, hasMore, fetchData } = useAnnotationsInfiniteScroll();

  return (
    <InfiniteScrollContainer
      items={items}
      loading={loading}
      hasMore={hasMore}
      fetchData={fetchData}
      className={classes.ordersList}
    >
      {items.map((item) => (
        <AnnotationItem key={item.uuid} {...item} />
      ))}
    </InfiniteScrollContainer>
  );
};
